import { useRef, useState } from "react";
import * as React from "react";
import { AppLogo } from "../../../applications/Shared/Process/AppLogo";
import { Lightbox } from "./Lightbox";

export interface IFullScreenTableModeButton {
    label?: string;
    children?: React.ReactChild | React.ReactChildren;
    onClick?: VoidFunction;
}

export const FullScreenTableModeButton = (props: IFullScreenTableModeButton) => {
    const wrapperRef = useRef(null);
    const { label } = props;
    const [isOpen, setIsOpen] = useState(false);

    // const handleClickOutside = () => {
    //     if (wrapperRef && !wrapperRef.current.contains(event.target)) setIsOpen(false);
    // }

    const ToggleMode = () => {
        setIsOpen(!isOpen);
    };

    // React.useEffect(() => {
    //     document.addEventListener('mousedown', handleClickOutside);
    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside);
    //     }
    // }, []);

    return (
        <>
            <button
                className={"full-screen-mode-button" + (isOpen ? " is-expanded" : "")}
                title="Expand full screen"
                onClick={() => {
                    if (props.onClick) {props.onClick();}
                    ToggleMode();
                }}
                aria-expanded={isOpen}
            >
                <span className="sr-only">{label ? label : "Show table in full screen mode"}</span>
                <span className="icon" aria-hidden={true} />
            </button>

            {isOpen && (
                <Lightbox
                    show={isOpen}
                    cssWrapper="lightbox-fullscreen"
                    title="Fullscreen"
                    onClose={() => setIsOpen(false)}
                >
                    <div className="lightbox-fullscreen-header">
                        <div className="container size-fluid">
                            <AppLogo />
                        </div>
                    </div>
                    <div className="lightbox-fullscreen-panel">
                        <div className="container size-1600">{props.children}</div>
                    </div>
                </Lightbox>
            )}
        </>
    );
};
